var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    width: "68.456mm",
    height: "110.72mm",
    viewBox: "0 0 68.456 110.72",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-128.2 -161.96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m172.33 270.03c1.2718-1.8837 2.7763-4.2397 3.3433-5.2355 0.56698-0.99578 2.5055-3.4527 4.3078-5.4598 3.0867-3.4374 4.3288-5.914 2.414-4.8129-0.47458 0.27286-3.4536 3.4905-6.62 7.1502l-5.757 6.654 0.50664-6.8843c5.9127-22.521 16.735-51.395 22.573-63.341 3.0723-6.2866 3.5722-8.1611 3.557-13.338-0.0368-12.964-8.9636-22.812-20.666-22.801-5.959 5e-3 -13.029 5.8755-13.038 10.825-5e-3 2.9572-0.95841 2.9696-4.093 0.0533-5.0892-4.735-12.911-6.0396-19.503-3.253-5.3636 2.2671-9.336 6.8847-10.661 12.392-2.2103 9.1892 2.8744 18.173 17.53 30.973 9.4835 8.2826 15.706 13.059 16.296 12.51 0.24754-0.23031-3.4617-3.5744-8.2429-7.4311-21.816-17.598-28.2-28.563-22.878-39.292 3.0849-6.2191 7.9253-9.0356 15.528-9.0356 5.2219 0 10.797 2.768 13.367 6.6364 2.4268 3.6534 3.5784 3.5859 3.5784-0.20977 0-4.128 2.0276-8.3363 5.0996-10.585 3.0611-2.2403 11.104-2.5687 15.157-0.61872 3.9945 1.9219 8.0469 6.7425 9.8028 11.661 2.5954 7.2703 1.6367 13.32-3.9548 24.956-4.5896 9.5506-19.781 50.712-21.091 59.899l-0.61386 4.3027-2.3813-5.5302c-2.3293-5.4095-8.2185-12.124-10.61-12.098-0.63583 5e-3 0.34319 1.2656 2.1753 2.7968 4.4604 3.7274 5.9355 6.3176 11.867 20.838 0.62121 1.5208 0.94433 1.336 3.0083-1.7211z",
    strokeWidth: 5.0695
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartarrow);
export default __webpack_public_path__ + "static/media/heartarrow.76032cb291eeea1241abf037fd285fe1.svg";
export { ForwardRef as ReactComponent };